import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalFade',
  props: {
    isVisible: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modal-fade" }, {
    default: _withCtx(() => [
      (__props.isVisible)
        ? _renderSlot(_ctx.$slots, "default", {}, undefined, undefined, 0)
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})